(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-carousel"] && !Shopify.designMode) return;
  try {
    
  class CollectionsCarousel {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-carousel-track]');
      this.prevBtn = element.querySelector('[data-carousel-prev]');
      this.nextBtn = element.querySelector('[data-carousel-next]');
      this.dotsContainer = element.querySelector('[data-carousel-dots]');
      this.cards = this.track.querySelectorAll('.category-card');

      if (this.cards.length === 0) return;

      this.currentIndex = 0;
      this.init();
    }

    init() {
      // Create dots
      if (this.dotsContainer) {
        this.cards.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'collections-carousel__dot' + (index === 0 ? ' collections-carousel__dot--active' : '');
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => this.goToSlide(index));
          this.dotsContainer.appendChild(dot);
        });
        this.dots = this.dotsContainer.querySelectorAll('.collections-carousel__dot');
      }

      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Update on scroll
      this.track.addEventListener('scroll', () => this.onScroll());

      // Initial state
      this.updateButtons();
    }

    onScroll() {
      const scrollLeft = this.track.scrollLeft;
      const cardWidth = this.cards[0].offsetWidth + parseInt(getComputedStyle(this.track).gap);
      const newIndex = Math.round(scrollLeft / cardWidth);

      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex;
        this.updateDots();
        this.updateButtons();
      }
    }

    goToSlide(index) {
      const cardWidth = this.cards[0].offsetWidth + parseInt(getComputedStyle(this.track).gap);
      this.track.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
      this.currentIndex = index;
      this.updateDots();
      this.updateButtons();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      }
    }

    next() {
      if (this.currentIndex < this.cards.length - 1) {
        this.goToSlide(this.currentIndex + 1);
      }
    }

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('collections-carousel__dot--active', index === this.currentIndex);
      });
    }

    updateButtons() {
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      if (this.nextBtn) {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 10;
      }
    }
  }

  document.querySelectorAll('[data-collections-carousel]').forEach(carousel => {
    new CollectionsCarousel(carousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluid-zebra-stripes"] && !Shopify.designMode) return;
  try {
    
(function() {
  class FluidZebraStripesAnimation {
    constructor(element) {
      this.element = element;
      this.canvas = null;
      this.ctx = null;
      this.animationId = null;
      this.time = 0;
      this.isVisible = false;
      this.observer = null;
      this.resizeHandler = null;
      this.init();
    }

    init() {
      const animationType = this.element.dataset.animationType;
      if (animationType === 'canvas') {
        this.canvas = this.element.querySelector('canvas');
        if (this.canvas) {
          this.ctx = this.canvas.getContext('2d');
          this.setupCanvas();
          this.setupIntersectionObserver();
        }
      }
    }

    destroy() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }

    setupCanvas() {
      this.resizeHandler = () => {
        const rect = this.element.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        this.canvas.width = rect.width * dpr;
        this.canvas.height = rect.height * dpr;
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.scale(dpr, dpr);
        this.canvas.style.width = rect.width + 'px';
        this.canvas.style.height = rect.height + 'px';
      };

      this.resizeHandler();
      window.addEventListener('resize', this.resizeHandler);
    }

    setupIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.startAnimation();
          } else {
            this.isVisible = false;
            this.stopAnimation();
          }
        });
      }, { threshold: 0.1 });

      this.observer.observe(this.element);
    }

    startAnimation() {
      if (this.animationId) return;
      this.animate();
    }

    stopAnimation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }

    animate() {
      if (!this.isVisible) return;

      const width = this.canvas.width / (window.devicePixelRatio || 1);
      const height = this.canvas.height / (window.devicePixelRatio || 1);
      const speed = parseFloat(this.element.dataset.animationSpeed) || 1.0;
      const amplitude = parseFloat(this.element.dataset.waveAmplitude) || 25;
      const stripeWidth = parseFloat(this.element.dataset.stripeWidth) || 30;
      const stripeColor = this.element.dataset.stripeColor || '#000000';
      const bgColor = this.element.dataset.bgColor || '#d4c5b0';

      this.ctx.fillStyle = bgColor;
      this.ctx.fillRect(0, 0, width, height);

      this.ctx.strokeStyle = stripeColor;
      this.ctx.lineWidth = stripeWidth;
      this.ctx.lineCap = 'round';

      const stripeSpacing = stripeWidth * 2;
      const numStripes = Math.ceil(width / stripeSpacing) + 4;

      for (let i = -2; i < numStripes; i++) {
        const baseX = i * stripeSpacing;

        this.ctx.beginPath();
        this.ctx.moveTo(baseX, -10);

        for (let y = 0; y <= height + 10; y += 5) {
          const wave1 = Math.sin(y * 0.008 + this.time * 0.5 * speed + i * 0.3) * amplitude;
          const wave2 = Math.sin(y * 0.012 + this.time * 0.3 * speed - i * 0.2) * (amplitude * 0.5);
          const wave3 = Math.sin(y * 0.004 + this.time * 0.7 * speed) * (amplitude * 0.3);

          const x = baseX + wave1 + wave2 + wave3;
          this.ctx.lineTo(x, y);
        }

        this.ctx.stroke();
      }

      this.time += 0.016;
      this.animationId = requestAnimationFrame(() => this.animate());
    }
  }

  function initFluidZebraStripes() {
    document.querySelectorAll('.fluid-zebra-stripes[data-animation-type="canvas"]').forEach(el => {
      if (!el.dataset.initialized) {
        el.dataset.initialized = 'true';
        new FluidZebraStripesAnimation(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFluidZebraStripes);
  } else {
    initFluidZebraStripes();
  }

  document.addEventListener('shopify:section:load', initFluidZebraStripes);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  let menuPreviousOverflow = '';

  function openMobileMenu() {
    menuPreviousOverflow = document.body.style.overflow;
    mobileMenu.inert = false;
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenu.classList.add('is-open');
    mobileOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    mobileMenuToggle.setAttribute('aria-expanded', 'true');
    mobileMenuClose.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu.classList.contains('is-open')) return;
    mobileMenuToggle.focus();
    mobileMenu.inert = true;
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.classList.remove('is-open');
    mobileOverlay.classList.remove('is-visible');
    document.body.style.overflow = menuPreviousOverflow;
    mobileMenuToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMobileMenu();
      }
      if (event.key !== 'Tab') return;
      const controls = [...mobileMenu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')]
        .filter((control) => !control.closest('[inert]') && control.getClientRects().length > 0);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (event) => {
      if (event.matches) closeMobileMenu();
    });
  }

  // Mobile submenu toggles
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(button => {
    button.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      const submenu = this.nextElementSibling;
      if (submenu) {
        submenu.inert = expanded;
        submenu.setAttribute('aria-hidden', String(expanded));
        submenu.style.maxHeight = expanded ? '0' : submenu.scrollHeight + 'px';
      }
    });
  });

  // Dropdown menus (desktop)
  document.querySelectorAll('.header__nav-link--dropdown').forEach(button => {
    button.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
    });
  });

  // Search toggle
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchBar = document.querySelector('[data-search-bar]');
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchIconOpen = document.querySelector('.header__search-icon-open');
  const searchIconClose = document.querySelector('.header__search-icon-close');

  if (searchToggle && searchBar) {
    function closeSearch(returnFocus) {
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
      searchBar.setAttribute('inert', '');
      searchToggle.setAttribute('aria-expanded', 'false');
      if (searchIconOpen) searchIconOpen.style.display = '';
      if (searchIconClose) searchIconClose.style.display = 'none';

      const results = searchBar.querySelector('[data-predictive-search-results]');
      if (results) results.classList.remove('is-open');
      if (returnFocus) searchToggle.focus();
    }

    function openSearch() {
      searchBar.removeAttribute('inert');
      searchBar.setAttribute('aria-hidden', 'false');
      searchBar.classList.add('is-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      if (searchIconOpen) searchIconOpen.style.display = 'none';
      if (searchIconClose) searchIconClose.style.display = '';
      if (searchInput) {
        setTimeout(function() { searchInput.focus(); }, 100);
      }
    }

    searchToggle.addEventListener('click', function() {
      const isOpen = searchBar.classList.contains('is-open');
      if (isOpen) {
        closeSearch(false);
      } else {
        openSearch();
      }
    });

    if (searchClose) {
      searchClose.addEventListener('click', function() {
        closeSearch(true);
      });
    }

    searchBar.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSearch(true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // --- Variant Data ---
  const variantsEl = document.querySelector('[data-product-variants]');
  const productDataEl = document.querySelector('[data-product-data]');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const productData = productDataEl ? JSON.parse(productDataEl.textContent) : {};

  // --- Helpers ---
  function formatMoney(cents) {
    const format = productData.money_format || '$' + String.fromCharCode(123,123) + 'amount' + String.fromCharCode(125,125);
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.floor(cents / 100).toString();
    const amountWithComma = amount.replace('.', ',');
    return format
      .replace(/\{\{amount_with_comma_separator\}\}/, amountWithComma)
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/, amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{amount_no_decimals\}\}/, amountNoDecimals)
      .replace(/\{\{amount\}\}/, amount);
  }

  function getSelectedOptions() {
    const options = [];
    document.querySelectorAll('.product__option').forEach(optionEl => {
      // Check radio buttons / swatches
      const checked = optionEl.querySelector('input[type="radio"]:checked');
      if (checked) {
        options.push(checked.value);
        return;
      }
      // Check dropdown
      const select = optionEl.querySelector('select');
      if (select) {
        options.push(select.value);
      }
    });
    return options;
  }

  function findVariant(selectedOptions) {
    if (!selectedOptions.length && variants.length === 1) return variants[0];
    return variants.find(v => {
      if (!v.options) return false;
      return v.options.every((opt, i) => opt === selectedOptions[i]);
    });
  }

  // --- Update Functions ---
  function updateVariantId(variant) {
    const input = document.querySelector('[data-variant-id]');
    if (input) input.value = variant ? variant.id : "";
  }

  function updatePrice(variant) {
    if (!variant) return;
    const saleEl = document.querySelector('[data-price-sale]');
    const compareEl = document.querySelector('[data-price-compare]');
    const regularEl = document.querySelector('[data-price-regular]');
    const badgeEl = document.querySelector('[data-sale-badge]');

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (saleEl) {
      saleEl.textContent = formatMoney(variant.price);
      saleEl.hidden = !onSale;
    }
    if (compareEl) {
      compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      compareEl.hidden = !onSale;
    }
    if (badgeEl) {
      badgeEl.hidden = !onSale;
    }
    if (regularEl) {
      regularEl.textContent = formatMoney(variant.price);
      regularEl.hidden = onSale;
    }

    // Update sticky bar price, compare-at, and discount badge
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyCompare = document.querySelector('[data-sticky-compare]');
    const stickyBadge = document.querySelector('[data-sticky-badge]');

    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
      stickyPrice.classList.toggle('product__sticky-bar-price--sale', onSale);
    }
    if (stickyCompare) {
      stickyCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      stickyCompare.hidden = !onSale;
    }
    if (stickyBadge) {
      if (onSale) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        stickyBadge.textContent = '-' + pct + '%';
        stickyBadge.hidden = false;
      } else {
        stickyBadge.hidden = true;
      }
    }
  }

  function updateButton(variant) {
    const btn = document.querySelector('[data-add-to-cart-button]');
    if (!btn) return;
    const textEl = btn.querySelector('[data-button-text]');
    const iconEl = btn.querySelector('[data-cart-icon]');
    const stickyBtn = document.querySelector('[data-sticky-add-to-cart]');

    if (!variant) {
      btn.disabled = true;
      if (textEl) textEl.textContent = btn.dataset.textSoldOut;
      if (iconEl) iconEl.hidden = true;
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = btn.dataset.textSoldOut; }
    } else if (!variant.available) {
      btn.disabled = true;
      if (textEl) textEl.textContent = btn.dataset.textSoldOut;
      if (iconEl) iconEl.hidden = true;
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = btn.dataset.textSoldOut; }
    } else {
      btn.disabled = false;
      if (textEl) textEl.textContent = btn.dataset.textAdd;
      if (iconEl) iconEl.hidden = false;
      if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = btn.dataset.textAdd; }
    }
  }

  function updateUrl(variant) {
    if (!variant || !productData.url) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function updateGallery(variant) {
    if (!variant) return;
    const gallery = document.querySelector('[data-product-gallery]');
    if (gallery) gallery.dispatchEvent(new CustomEvent('product:variant-change', { detail: variant }));
  }

  function updateSelectedDisplay(input) {
    const optionContainer = input.closest('.product__option');
    if (!optionContainer) return;
    const selectedDisplay = optionContainer.querySelector('.product__option-selected');
    if (selectedDisplay) {
      selectedDisplay.textContent = ': ' + input.value;
    }
  }

  function updateVisualSelection(input) {
    const parent = input.closest('.product__option-buttons, .product__option-swatches');
    if (!parent) return;
    parent.querySelectorAll('label').forEach(label => {
      label.classList.remove('product__option-button--selected', 'product__option-swatch--selected');
    });
    input.parentElement.classList.add(
      input.closest('.product__option-buttons') ? 'product__option-button--selected' : 'product__option-swatch--selected'
    );
  }

  function updateUnavailableOptions() {
    const selectedOptions = getSelectedOptions();
    document.querySelectorAll('.product__option').forEach((optionEl, optionIndex) => {
      const inputs = optionEl.querySelectorAll('input[type="radio"], select option');
      inputs.forEach(input => {
        const isSelect = input.tagName === 'OPTION';
        const value = input.value;

        // Build a test option set with this value swapped in
        const testOptions = [...selectedOptions];
        testOptions[optionIndex] = value;
        const matchingVariant = optionEl.hasAttribute('data-color-option')
          ? variants.find(variant => variant.available && variant.options.every((option, index) =>
              document.querySelectorAll('.product__option')[index]?.hasAttribute('data-size-option') || option === testOptions[index]))
          : findVariant(testOptions);

        const isUnavailable = !matchingVariant || !matchingVariant.available;

        if (isSelect) {
          input.disabled = isUnavailable;
        } else {
          input.disabled = isUnavailable;
          input.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
          const soldOutLabel = document.querySelector('[data-add-to-cart-button]')?.dataset.textSoldOut;
          input.setAttribute('aria-label', value + (isUnavailable && soldOutLabel ? ' (' + soldOutLabel + ')' : ''));
          const label = input.parentElement;
          if (label) {
            const hiddenLabel = label.querySelector('span.visually-hidden');
            if (hiddenLabel) hiddenLabel.textContent = value + (isUnavailable && soldOutLabel ? ' — ' + soldOutLabel : '');
            label.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
            label.classList.toggle('product__option-button--unavailable',
              isUnavailable && label.classList.contains('product__option-button'));
            label.classList.toggle('product__option-swatch--unavailable',
              isUnavailable && label.classList.contains('product__option-swatch'));
          }
        }
      });
    });
  }

  // --- Main Variant Change Handler ---
  function onVariantChange(changedInput) {
    const selectedOptions = getSelectedOptions();
    let variant = findVariant(selectedOptions);
    const changedOption = changedInput?.closest('.product__option');
    if (changedOption?.hasAttribute('data-color-option') && (!variant || !variant.available)) {
      const optionElements = [...document.querySelectorAll('.product__option')];
      variant = variants.find(candidate => candidate.available && candidate.options.every((value, index) =>
        optionElements[index]?.hasAttribute('data-size-option') || value === selectedOptions[index]));
      if (variant) variant.options.forEach((value, index) => {
        const optionEl = optionElements[index];
        const radio = optionEl?.querySelector(`input[value="${CSS.escape(value)}"]`);
        const select = optionEl?.querySelector('select');
        if (radio) {
          radio.checked = true;
          updateVisualSelection(radio);
          updateSelectedDisplay(radio);
        } else if (select) select.value = value;
      });
    }
    updateVariantId(variant);
    updatePrice(variant);
    updateButton(variant);
    updateQuantityMax(variant);
    updateUrl(variant);
    updateGallery(variant);
    const selection = document.querySelector('[data-selected-options]');
    if (selection) selection.textContent = getSelectedOptions().join(' · ');
    updateUnavailableOptions();
  }

  // --- Bind Event Listeners ---

  // Variant option change (buttons, swatches, dropdowns)
  document.querySelectorAll('.product__option-button input, .product__option-swatch input').forEach(input => {
    input.addEventListener('change', () => {
      updateVisualSelection(input);
      updateSelectedDisplay(input);
      onVariantChange(input);
    });
  });

  document.querySelectorAll('.product__option-select').forEach(select => {
    select.addEventListener('change', () => {
      onVariantChange(select);
    });
  });

  // Quantity controls
  // Disable the +/- buttons at the bounds (Shopify's own themes do this) rather
  // than letting a click silently no-op, which reads as "broken".
  function updateButtonStates(wrapper) {
    if (!wrapper) wrapper = document.querySelector('.product__quantity-wrapper');
    if (!wrapper) return;
    const input = wrapper.querySelector('input');
    if (!input) return;
    const minusBtn = wrapper.querySelector('[data-quantity-minus]');
    const plusBtn = wrapper.querySelector('[data-quantity-plus]');
    const value = parseInt(input.value, 10) || 1;
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const max = parseInt(input.getAttribute('max'), 10);
    if (minusBtn) minusBtn.disabled = value <= min;
    if (plusBtn) plusBtn.disabled = !isNaN(max) && value >= max;
  }

  document.querySelectorAll('[data-quantity-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.product__quantity-wrapper');
      const input = wrapper.querySelector('input');
      const min = parseInt(input.getAttribute('min'), 10) || 1;
      const step = parseInt(input.getAttribute('step'), 10) || 1;
      const next = parseInt(input.value, 10) - step;
      if (next >= min) {
        input.value = next;
        updateQuantityInput(input.value);
      }
      updateButtonStates(wrapper);
    });
  });

  document.querySelectorAll('[data-quantity-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.product__quantity-wrapper');
      const input = wrapper.querySelector('input');
      const step = parseInt(input.getAttribute('step'), 10) || 1;
      const max = parseInt(input.getAttribute('max'), 10);
      let next = parseInt(input.value, 10) + step;
      if (!isNaN(max)) next = Math.min(next, max); // clamp at ceiling; button also disables
      input.value = next;
      updateQuantityInput(input.value);
      updateButtonStates(wrapper);
    });
  });

  document.querySelectorAll('.product__quantity-input').forEach(input => {
    input.addEventListener('change', () => {
      const wrapper = input.closest('.product__quantity-wrapper');
      // Clamp manual entry to [min, max].
      const min = parseInt(input.getAttribute('min'), 10) || 1;
      let value = parseInt(input.value, 10);
      if (isNaN(value) || value < min) value = min;
      const max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && value > max) value = max;
      input.value = value;
      updateQuantityInput(value);
      updateButtonStates(wrapper);
    });
  });

  // Set the initial disabled state on load.
  document.querySelectorAll('.product__quantity-wrapper').forEach(updateButtonStates);

  function updateQuantityInput(value) {
    const hiddenInput = document.querySelector('[data-quantity-input]');
    if (hiddenInput) {
      hiddenInput.value = value;
    }
  }

  // Keep the quantity ceiling in sync with the selected variant's stock.
  function updateQuantityMax(variant) {
    const input = document.querySelector('.product__quantity-input');
    if (!input || !variant) return;
    const limits = [];
    if (variant.inventory_management && variant.inventory_policy === 'deny' && typeof variant.inventory_quantity === 'number') limits.push(variant.inventory_quantity);
    if (variant.quantity_rule?.max != null) limits.push(variant.quantity_rule.max);
    const min = variant.quantity_rule?.min || 1;
    const step = variant.quantity_rule?.increment || 1;
    input.min = min;
    input.step = step;
    if (limits.length) input.max = Math.min(...limits);
    else input.removeAttribute('max');
    let value = Math.max(min, parseInt(input.value, 10) || min);
    value = min + Math.floor((value - min) / step) * step;
    if (limits.length && Math.min(...limits) >= min) value = Math.min(value, Math.min(...limits));
    input.value = value;
    updateQuantityInput(value);
    updateButtonStates(input.closest('.product__quantity-wrapper'));
  }

  // Copy link button
  document.querySelectorAll('.product__share-copy').forEach(btn => {
    btn.addEventListener('click', async () => {
      const url = btn.dataset.copyUrl;
      try {
        await navigator.clipboard.writeText(url);
        btn.classList.add('product__share-copy--success');
        setTimeout(() => btn.classList.remove('product__share-copy--success'), 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    });
  });

  // Native Share API (for mobile devices)
  if (navigator.share) {
    document.querySelectorAll('.product__share-native').forEach(btn => {
      btn.hidden = false;
      btn.addEventListener('click', async () => {
        try {
          await navigator.share({
            title: btn.dataset.shareTitle,
            text: btn.dataset.shareText,
            url: btn.dataset.shareUrl
          });
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Share failed:', err);
          }
        }
      });
    });
  }

  // --- Sticky Mobile Add-to-Cart ---
  const stickyBar = document.querySelector('.product__sticky-bar');
  const mainButton = document.querySelector('[data-add-to-cart-button]');
  const buyButtonsBlock = mainButton ? (mainButton.closest('.product__block--buy-buttons') || mainButton) : null;

  if (stickyBar && buyButtonsBlock) {
    let pastBuyButtons = false;
    let nearFooter = false;
    const mobile = window.matchMedia('(max-width: 1023px)');
    const syncSticky = () => {
      const visible = mobile.matches && pastBuyButtons && !nearFooter;
      stickyBar.classList.toggle('product__sticky-bar--visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
      stickyBar.inert = !visible;
    };
    new IntersectionObserver(([entry]) => {
      pastBuyButtons = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      syncSticky();
    }).observe(buyButtonsBlock);
    const footer = document.querySelector('footer');
    if (footer) new IntersectionObserver(([entry]) => {
      nearFooter = entry.isIntersecting;
      syncSticky();
    }, { rootMargin: '100px 0px 0px 0px' }).observe(footer);
    mobile.addEventListener('change', syncSticky);
    stickyBar.querySelector('[data-sticky-add-to-cart]')?.addEventListener('click', () => {
      const form = document.querySelector('[data-product-form]');
      if (form && mainButton && !mainButton.disabled) form.requestSubmit(mainButton);
    });
    syncSticky();
  }

  // --- Init from URL ---
  (function initFromUrl() {
    if (variants.length === 0) return;
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (!variantId) {
      // Initial unavailable option marking
      updateUnavailableOptions();
      return;
    }

    const variant = variants.find(v => String(v.id) === variantId);
    if (!variant || !variant.options) return;

    // Pre-select each option
    variant.options.forEach((value, index) => {
      const optionEl = document.querySelectorAll('.product__option')[index];
      if (!optionEl) return;

      // Radio / swatch
      const radio = optionEl.querySelector(`input[value="${CSS.escape(value)}"]`);
      if (radio) {
        radio.checked = true;
        updateVisualSelection(radio);
        updateSelectedDisplay(radio);
        return;
      }

      // Dropdown
      const select = optionEl.querySelector('select');
      if (select) {
        select.value = value;
      }
    });

    onVariantChange();
  })();

  document.querySelectorAll('[data-open-size-guide]').forEach(link => {
    link.addEventListener('click', event => {
      const guide = document.getElementById(link.hash.slice(1));
      if (!guide) return;
      event.preventDefault();
      guide.open = true;
      guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      guide.querySelector('summary')?.focus({ preventScroll: true });
    });
  });
  document.querySelector('[data-change-options]')?.addEventListener('click', event => {
    const options = document.querySelector('.product__variants');
    if (!options) return;
    event.preventDefault();
    options.scrollIntoView({ behavior: 'smooth', block: 'center' });
    options.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();
})();
